import { http } from "./http";

export const authApi = {
  login: ({ email, password }) =>
    http.post("/auth/login", { email, password }).then((r) => r.data),

  me: () => http.get("/auth/me").then((r) => r.data),

  logout: () => http.post("/auth/logout").then((r) => r.data), // se existir
};
